module.exports = __webpack_public_path__ + "static/media/canada_mototurismo_1.aa03b1db.jpg";